const SldsCheckboxButton = () => {
    return (
        <label class="slds-checkbox-button slds-checkbox-button_is-checked" for="example-unique-id-118">
            <input type="checkbox" class="slds-assistive-text" id="example-unique-id-118" value="example-unique-id-118" checked="" />
            <span class="slds-icon_container slds-icon-utility-check slds-current-color" title="Description of icon when needed">
                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                </svg>
                <span class="slds-assistive-text">Add product</span>
            </span>
        </label>
    )
}

export default SldsCheckboxButton;